import * as React from 'react'

const Important = (props: any) => (
  <svg {...props} viewBox='0 0 16 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0 12.6667H14.6667L7.33333 0L0 12.6667ZM8 10.6667H6.66667V9.33333H8V10.6667ZM8 8H6.66667V5.33333H8V8Z'
      transform='translate(.667 .333)'
      fill='#fff'
    />
  </svg>
)

export default Important



// WEBPACK FOOTER //
// ./src/components/icons/ui/Important.tsx